<template>
    <div>
        <section class="py-8 py-md-11 border-bottom">
            <div class="container">
                <div class="row mb-4">
                    <div class="col-12 text-center">
                        <div class="ml-4">
                            <h4 class="font-weight-bold text-uppercase text-success mb-0">
                                About Us
                            </h4>
                        </div>
                    </div>
                </div>
                <div class="row justify-content-center">
                    <div class="col-12 col-md-10 col-lg-10 text-center">

                        <!-- Headin -->
                        <h1 class="display-2">
                            Collaborate. Corroborate. Contribute
                        </h1>

                        <!-- Text -->
                        <p class="lead text-muted mb-7 mb-md-9">
                            As a company we aim to provide a Blockchain platform to build trust, showcase provenance, secure identities and most importantly bridge the digital trust deficit for a
                            sustainable world.
                        </p>

                    </div>
                </div> <!-- / .row -->
                <div class="row">
                    <div class="col-12">

                        <!-- Image -->
                        <div class="form-row">
                            <div class="col-5">
                                <a class="d-block lift lift-lg mb-3" data-fancybox="gallery" data-height="350" data-width="440" href="/photos/about/3.jpg">
                                    <img alt="..." class="img-fluid rounded shadow-lg" src="/photos/about/3.jpg">
                                </a>
                                <a class="d-block lift lift-lg" data-fancybox="gallery" data-height="460" data-width="810" href="/photos/about/4.jpg">
                                    <img alt="..." class="img-fluid rounded shadow-lg" src="/photos/about/4.jpg">
                                </a>

                            </div>
                            <div class="col-7">
                                <div class="form-row">
                                    <div class="col-6">
                                        <a class="d-block lift lift-lg" data-fancybox="gallery" data-height="350" data-width="440" href="/photos/about/9.jpg">
                                            <img alt="..." class="img-fluid rounded shadow-lg" src="/photos/about/9.jpg">
                                        </a>
                                    </div>
                                    <div class="col-6">
                                        <a class="d-block lift lift-lg" data-fancybox="gallery" data-height="350" data-width="440" href="/photos/about/6.jpg">
                                            <img alt="..." class="img-fluid rounded shadow-lg" src="/photos/about/6.jpg">
                                        </a>

                                    </div>
                                </div>
                                <div class="form-row mt-4 team">
                                    <div class="col-12">
                                        <a class="d-block lift lift-lg" data-fancybox="gallery" data-height="460" data-width="810" href="/photos/about/8.jpg">
                                            <img alt="..." class="img-fluid rounded shadow-lg" src="/photos/about/8.jpg">
                                        </a>

                                    </div>
                                </div>

                            </div>
                        </div>

                        <div class="form-row mt-4 team">
                            <div class="col-5">
                                <a class="d-block lift lift-lg mt-1" data-fancybox="gallery" data-height="267" data-width="460" href="/photos/about/2.jpg">
                                    <img alt="..." class="img-fluid rounded shadow-lg" src="/photos/about/2.jpg">
                                </a>
                            </div>
                            <div class="col-7">

                                <a class="d-block lift lift-lg" data-fancybox="gallery" data-height="1960" data-width="4032" href="/photos/about/20181116_140041.jpg">
                                    <img alt="..." class="img-fluid rounded shadow-lg" src="/photos/about/20181116_140041.jpg">
                                </a>
                            </div>
                        </div>

                    </div>
                </div> <!-- / .row -->
            </div> <!-- / .container -->
        </section>

        <section class="pt-6 pt-md-8">
            <div class="container pb-6 pb-md-8">
                <div class="row align-items-center">
                    <div class="col-12 col-md">

                        <!-- Heading -->
                        <h3 class="font-weight-bold mb-1">
                            Interested in joining our team?
                        </h3>

                        <!-- Text -->
                        <p class="font-size-lg text-muted mb-5 mb-md-0">
                            Hit us up and we'll get in touch with you.
                        </p>

                    </div>
                    <div class="col-12 col-md-auto">

                        <!-- Button -->
                        <a class="btn btn-success lift" data-toggle="modal" href="#modalapply">
                            Apply now
                        </a>

                    </div>
                </div> <!-- / .row -->
            </div> <!-- / .container -->
        </section>

        <div aria-hidden="true" aria-labelledby="modalapply" class="modal fade" data-backdrop="static" data-keyboard="false" id="modalapply" role="dialog" style="display: none" tabindex="-1">
            <div class="modal-dialog modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-body">

                        <!-- Close -->
                        <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                            <span aria-hidden="true" class="text-success">×</span>
                        </button>

                        <div class="row">
                            <div class="col-12">


                                <!-- Form -->
                                <form @submit.prevent="handleSubmit">
                                    <div class="row">
                                        <div class="col-12 col-md-6">

                                            <div class="form-group mb-5">
                                                <label for="applyName">
                                                    Full name
                                                </label>
                                                <input class="form-control" data-vv-as="Full Name" id="applyName" name="name" placeholder="Full name" type="text" v-model="apply_form.name"
                                                       v-validate="'required'">
                                                <div class="text-danger" v-if="submitted && errors.has('name')">{{ errors.first('name') }}</div>
                                            </div>

                                        </div>
                                        <div class="col-12 col-md-6">

                                            <div class="form-group mb-5">
                                                <label for="applyEmail">
                                                    Email
                                                </label>
                                                <input class="form-control" data-vv-as="Email" id="applyEmail" name="email" placeholder="hello@domain.com" type="text" v-model="apply_form.email"
                                                       v-validate="'required|email'">
                                                <div class="text-danger" v-if="submitted && errors.has('email')">{{ errors.first('email') }}</div>
                                            </div>

                                        </div>
                                    </div> <!-- / .row -->
                                    <!--                                    <div class="row">-->
                                    <!--                                        <div class="col-12 col-md-6">-->

                                    <!--                                            <div class="form-group mb-5">-->
                                    <!--                                                <p class="mb-2">-->
                                    <!--                                                    Cover letter-->
                                    <!--                                                </p>-->
                                    <!--                                                <div class="custom-file">-->
                                    <!--                                                    <input class="custom-file-input" id="applyCover" type="file">-->
                                    <!--                                                    <label class="custom-file-label" for="applyCover">-->
                                    <!--                                                        Choose file-->
                                    <!--                                                    </label>-->
                                    <!--                                                </div>-->
                                    <!--                                            </div>-->

                                    <!--                                        </div>-->
                                    <!--                                        <div class="col-12 col-md-6">-->

                                    <!--                                            <div class="form-group mb-5">-->
                                    <!--                                                <p class="mb-2">-->
                                    <!--                                                    Resume-->
                                    <!--                                                </p>-->
                                    <!--                                                <div class="custom-file">-->
                                    <!--                                                    <input class="custom-file-input" id="applyResume" type="file">-->
                                    <!--                                                    <label class="custom-file-label" for="applyResume">-->
                                    <!--                                                        Choose file-->
                                    <!--                                                    </label>-->
                                    <!--                                                </div>-->
                                    <!--                                            </div>-->

                                    <!--                                        </div>-->
                                    <!--                                    </div> &lt;!&ndash; / .row &ndash;&gt;-->
                                    <div class="row">
                                        <div class="col-12">

                                            <div class="form-group mb-5">
                                                <label for="applyMessage">
                                                    Why do you want to join Qlikchain?
                                                </label>
                                                <textarea class="form-control" data-vv-as="Apply Message" id="applyMessage" name="message" placeholder="Let us know!(Max 500 words)" rows="5"
                                                          v-model="apply_form.message" v-validate="'required'"></textarea>
                                                <div class="text-danger" v-if="submitted && errors.has('message')">{{ errors.first('message') }}</div>
                                            </div>

                                        </div>
                                    </div> <!-- / .row -->
                                    <div class="row align-items-center">
                                        <div class="col-12 col-md">
                                            <h6 class="text-muted">* Send your resume to <a href="mailto:hr@qlikchain.com">hr@qlikchain.com</a>.</h6>
                                            <!-- Submit -->
                                            <button class="btn btn-success mb-6 mb-md-0 lift" type="submit">
                                                Apply now <i class="fe fe-arrow-right ml-3"></i>
                                            </button>

                                        </div>
                                        <!--                                        <div class="col-12 col-md-auto">-->

                                        <!--                                            <p class="font-size-sm text-muted mb-0">-->
                                        <!--                                                Application will be send securely and remain private-->
                                        <!--                                            </p>-->

                                        <!--                                        </div>-->
                                    </div> <!-- / .row -->
                                </form>


                            </div>
                        </div> <!-- / .row -->

                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import axios from 'axios';
    import Flickity from 'vue-flickity';

    export default {
        name: "about",
        components: {
            Flickity
        },
        data() {
            return {
                flickityOptions: {
                    fade: true,
                    initialIndex: 0,
                    prevNextButtons: true,
                    pageDots: false,
                    wrapAround: true,
                    imagesLoaded: true,
                    adaptiveHeight: false,
                    autoplay: 500
                },
                apply_form: {
                    name: null,
                    email: null,
                    message: null,
                    formContext: 'Apply Recruitment'
                },
                submitted: false
            }
        },
        mounted() {

        },
        methods: {
            next() {
                this.$refs.flickity.next();
            },

            previous() {
                this.$refs.flickity.previous();
            },
            handleSubmit(e) {
                this.submitted = true;
                this.$validator.validate()
                .then(valid => {
                    if(valid) {
                        this.save();
                    }
                });
            },
            async save() {
                let formPostUrl = 'https://4yt255du5e.execute-api.us-west-2.amazonaws.com/contactFormPost/';
                try {
                    await axios.post(formPostUrl, JSON.stringify(this.apply_form), {
                        headers: {
                            'Content-Type': 'application/json',
                        }
                    });
                    this.$swal('Request Sent Successfully', 'Our Executive will reach you soon.', 'success');
                    await this.reset();
                    $('#modalapply').modal('toggle');
                } catch(e) {
                    this.$swal('Request Sent Failed', 'Please try again later', 'error');
                    await this.reset();
                }
            },
            async reset() {
                this.apply_form = {
                    name: null,
                    email: null,
                    message: null,
                    formContext: 'Apply Recruitment'
                };

                this.submitted = false;
            }
        },
    }
</script>

<style scoped>
    .flickity-button {
        display: flex;
        align-items: center;
        justify-content: center;
        width: calc(1.6em + 1.625rem + 2px);
        height: calc(1.6em + 1.625rem + 2px);
        background-color: #335eea;
        box-shadow: 0 0.5rem 1.5rem rgba(22, 28, 45, .05);
        color: #fff;
    }

    .flickity-viewport {
        height: 1224.64px !important;
        touch-action: pan-y !important;
    }

    .display-2 {
        font-size: 2.3125rem;
    }

    @media (max-width: 768px) {
        .team {
            margin-top: 2.5rem !important;
        }
    }

    @media (max-width: 425px) {
        .team {
            margin-top: 1.9rem !important;
        }
    }

    @media (max-width: 375px) {
        .team {
            margin-top: 1.8rem !important;
        }
    }

    @media (max-width: 320px) {
        .team {
            margin-top: 1.6rem !important;
        }
    }

</style>